export function shouldSendOnEnter(event, touchKeyboard = false) {
  return event.key === 'Enter' && !event.shiftKey && !event.isComposing &&
    !event.nativeEvent?.isComposing && event.keyCode !== 229 && !touchKeyboard;
}
